<div
  fxLayoutAlign="start center"
  fxLayout="row"
  fxLayoutGap="20px"
  (click)="goBack()"
  class="link"
>
  <div>
    <img src="assets/icons/left-arrow-icon.svg" alt="" />
  </div>
  <div class="equipment-id">
    <h2 class="ui primary header">My Profile</h2>
  </div>
</div>

<hr />
<div *ngIf="success || error">
  <esl-message-toast
    [(message)]="success"
    [messageType]="'success'"
  ></esl-message-toast>
  <esl-message-toast [(message)]="error"></esl-message-toast>
</div>

<div fxLayout="row" fxLayoutGap="30px" appMargin marginT="10">
  <div fxFlex="20%" fxLayout="column" fxLayoutGap="10px">
    <div
      class="side-panel text-center"
      appPadding="5"
      fxLayout="column"
      fxLayoutGap="10px"
      fxLayoutAlign="space-between center"
    >
      <div fxFlex>
        <img
          [src]="image"
          class="ui circular image"
          style="object-fit: cover"
        />
      </div>
      <div fxFlex>
        <button
          class="ui primary button"
          (click)="popModal()"
          [ngClass]="{ loading: pending }"
        >
          Change
        </button>
      </div>
    </div>
  </div>

  <div fxFlex="grow">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <h3 appMargin marginB="0">Profile Details</h3>
      <button (click)="edit()" class="ui tiny icon button">
        <i class="pencil icon"></i>
      </button>
    </div>
    <hr />

    <div class="ui vertical basic segment">
      <div fxLayout="row">
        <div fxFlex="30%"><strong>First Name</strong></div>
        <div fxFlex="grow">{{ user?.firstName }}</div>
      </div>
      <div class="ui divider"></div>

      <div fxLayout="row">
        <div fxFlex="30%"><strong>Last Name</strong></div>
        <div fxFlex="grow">{{ user?.lastName }}</div>
      </div>
      <div class="ui divider"></div>

      <div fxLayout="row">
        <div fxFlex="30%"><strong>Middle Name</strong></div>
        <div fxFlex="grow">{{ user?.middleName }}</div>
      </div>
      <div class="ui divider"></div>

      <div fxLayout="row">
        <div fxFlex="30%"><strong>Role</strong></div>
        <div fxFlex="grow">{{ user?.roleId?.roleName }}</div>
      </div>
      <div class="ui divider"></div>

      <div fxLayout="row">
        <div fxFlex="30%"><strong>User Type</strong></div>
        <div fxFlex="grow">{{ user?.userType }}</div>
      </div>
      <div class="ui divider"></div>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between center">
      <h3 appMargin marginB="0">Username and Email</h3>
    </div>
    <hr />
    <div class="ui vertical basic segment">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div fxFlex="30%"><strong>Username</strong></div>
        <div fxFlex="grow">{{ user?.username }}</div>
        <div fxFlex="10%" class="text-right">
          <button (click)="username(true)" class="ui tiny icon button">
            <i class="pencil icon"></i>
          </button>
        </div>
      </div>
      <div class="ui divider"></div>
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div fxFlex="30%"><strong>Email</strong></div>
        <div fxFlex="grow">{{ user?.appUserEmail }}</div>
        <div fxFlex="10%" class="text-right">
          <button (click)="username(false)" class="ui tiny icon button">
            <i class="pencil icon"></i>
          </button>
        </div>
      </div>
      <div class="ui divider"></div>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between center">
      <h3 appMargin marginB="0">Availability</h3>
    </div>
    <hr />
    <div class="ui vertical basic segment">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div fxFlex="30%"><strong>Status</strong></div>
        <div fxFlex="grow">
          {{ userAvailiable?.available ? "Available" : "Unavailable" }}
        </div>
        <div fxFlex="10%" class="text-right">
          <button
            (click)="availiable(userAvailiable?.available)"
            class="ui tiny icon button"
          >
            <i class="pencil icon"></i>
          </button>
        </div>
      </div>
      <div class="ui divider"></div>
    </div>
  </div>
</div>

<!-- <div class="ui vertical basic segment">
		<div fxLayout="row" fxLayoutAlign='start center'>
		<div fxFlex="40%"><img src="assets/avatar/1.jpg" class="ui tiny image"/></div>
		<div fxFlex="grow"><button class="ui  button" (click)="changeLogo()">Change Logo</button></div>
	</div>
	<div class="ui divider"></div>

	<div fxLayout="row">
		<div fxFlex="40%"><strong>RC Number</strong></div>
		<div fxFlex="grow">5069876354.</div>
	</div>
	<div class="ui divider"></div>

		<div fxLayout="row">
		<div fxFlex="40%"><strong>Tax Identification Number</strong></div>
		<div fxFlex="grow">9385023JF.</div>
	</div>
	<div class="ui divider"></div>


		<div fxLayout="row">
		<div fxFlex="40%"><strong>Address</strong></div>
		<div fxFlex="grow">4140 Parker Rd. Allentown, New Mexico 31134</div>
	</div>
	<div class="ui divider"></div>


		<div fxLayout="row">
		<div fxFlex="40%"><strong>Main Contact</strong></div>
		<div fxFlex="grow">Farida Aliyu.</div>
	</div>
	<div class="ui divider"></div>


		<div fxLayout="row">
		<div fxFlex="40%"><strong>Email</strong></div>
		<div fxFlex="grow">tim.jennings@example.com</div>
	</div>
	<div class="ui divider"></div>

		<div fxLayout="row">
		<div fxFlex="40%"><strong>Phone Number</strong></div>
		<div fxFlex="grow">0907 315 6551.</div>
	</div>
	<div class="ui divider"></div>

		<div fxLayout="row">
		<div fxFlex="40%"><strong>Website</strong></div>
		<div fxFlex="grow">www.lionbrand.com</div>
	</div>
	<div class="ui divider"></div>

		<div fxLayout="row">
		<div fxFlex="40%"><strong>Company Type</strong></div>
		<div fxFlex="grow">Limited Liability</div>
	</div>
	<div class="ui divider"></div>

		<div fxLayout="row">
		<div fxFlex="40%"><strong>Ownership Type</strong></div>
		<div fxFlex="grow">Partnership</div>
	</div>
	<div class="ui divider"></div>

</div> -->
<ng-template let-context let-modal="modal" #uploadTemplate>
  <div class="header">Change Profile Image</div>
  <div class="content">
    <!-- <div class="ui basic segment"> -->
    <div fxLayout="row" fxLayoutGap="10px">
      <div fxFlex="50%">
        <img-cropper
          #cropper
          [image]="data"
          [settings]="cropperSettings"
        ></img-cropper>
        <div class="file-upload">
          <input
            id="custom-input"
            #uploadDoc
            type="file"
            accept=".jpg, .jpeg, .png"
            #uploader
            (change)="fileChangeListener($event)"
            placeholder="Browse for documents"
            onclick="value = null"
          />
        </div>
      </div>
      <div fxFlex="50%" class="text-right">
        <div>
          <img
            [src]="data?.image"
            [width]="cropperSettings.croppedWidth"
            [height]="cropperSettings.croppedHeight"
          />
        </div>
      </div>
    </div>
    <!-- </div> -->
  </div>
  <div class="actions">
    <button
      class="ui basic primary button"
      (click)="modal.deny('approved')"
      autofocus
    >
      Cancel
    </button>
    <button
      class="ui primary button"
      (click)="modal.approve('approved')"
      autofocus
    >
      Upload Image
    </button>
  </div>
</ng-template>
